import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Info, FileText, Shield } from 'lucide-react';
import { getAppVersion, getPlatform, openExternalUrl } from '../../services/api';
import './SettingsPage.css';

const TERMS_URL = 'https://impartial-ocicat-c23.notion.site/2314858496678040b33fcd7f872dd064?pvs=74';
const PRIVACY_URL = 'https://impartial-ocicat-c23.notion.site/172485849667804398d8cbfeafcebd27';

const SettingsPage = () => {
  const navigate = useNavigate();
  const [webVersion, setWebVersion] = useState('');
  const [nativeVersion, setNativeVersion] = useState(null);

  useEffect(() => {
    document.title = '설정 | 코인특공대';

    fetch('/version.json')
      .then((r) => r.json())
      .then((data) => setWebVersion(data.version || ''))
      .catch(() => {});

    if (getPlatform() !== 'web') {
      getAppVersion().then((v) => setNativeVersion(v));
    }

    return () => { document.title = '코인특공대'; };
  }, []);

  return (
    <div className="settings-page-container">
      <div className="far-header">
        <div className="far-header-left">
          <span className="far-header-report-type">SETTINGS</span>
          <div className="far-header-title-row">
            <span className="far-header-title">설정</span>
          </div>
        </div>
      </div>

      <div className="settings-page-body">
        <div className="settings-group">
          <h2 className="settings-group-label">앱 정보</h2>
          <div className="settings-card">
            <div className="settings-row">
              <div className="settings-row-icon">
                <Info size={18} />
              </div>
              <div className="settings-row-content">
                <span className="settings-row-label">웹 버전</span>
              </div>
              <span className="settings-row-value">{webVersion || '-'}</span>
            </div>
            {nativeVersion !== null && (
              <div className="settings-row">
                <div className="settings-row-icon">
                  <Info size={18} />
                </div>
                <div className="settings-row-content">
                  <span className="settings-row-label">앱 버전</span>
                </div>
                <span className="settings-row-value">{nativeVersion || '-'}</span>
              </div>
            )}
          </div>
        </div>

        {/* <div className="settings-group">
          <h2 className="settings-group-label">법적 고지</h2>
          <div className="settings-card">
            <button
              className="settings-row settings-row-link"
              onClick={() => openExternalUrl(TERMS_URL)}
            >
              <div className="settings-row-icon">
                <FileText size={18} />
              </div>
              <div className="settings-row-content">
                <span className="settings-row-label">이용약관</span>
              </div>
              <ChevronRight size={18} className="settings-chevron" />
            </button>

            <button
              className="settings-row settings-row-link"
              onClick={() => openExternalUrl(PRIVACY_URL)}
            >
              <div className="settings-row-icon">
                <Shield size={18} />
              </div>
              <div className="settings-row-content">
                <span className="settings-row-label">개인정보처리방침</span>
              </div>
              <ChevronRight size={18} className="settings-chevron" />
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default SettingsPage;
